import React from 'react';
import { Tooltip, notify } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { EXTERNAL_ROUTES } from '../../../constants/app';
import { LinkCopiedToClipboardNotification } from '../../../types/notifications';
import { useInView } from 'react-intersection-observer';
import { EditorBlock } from 'draft-js';
import styled from 'styled-components';
import { useSidebarStore } from '../../../stores/sidebarStore';
import { useGuideStore } from '../../../stores/guideStore';
import { IconLink } from '@bynder/icons';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomTitleBlock = (props: any) => {
  const { translate } = useTranslate();
  const setVisibleSidebarElements = useSidebarStore(
    state => state.setVisibleSidebarElements,
  );
  const [ref, inView] = useInView();
  const activeGuideId = useGuideStore(s => s.activeGuideId);
  const activePageId = useGuideStore(s => s.activePageId);

  const blockKey = props.block.getKey();
  const link = `${EXTERNAL_ROUTES.PAGE(
    activeGuideId,
    activePageId,
  )}#${blockKey}`;

  const handleClick = () => {
    navigator.clipboard.writeText(link);
    notify(LinkCopiedToClipboardNotification);
  };

  const textIsEmpty = () => {
    const text = props.block.getText();

    if (!text.length) return true;

    // clear spaces if first character is a space
    return text.charAt(0) === ' '
      ? text.replace(/\s/g, '').length === 0
      : false;
  };

  React.useEffect(() => {
    setVisibleSidebarElements({
      [blockKey]: inView,
    });
  }, [inView, setVisibleSidebarElements, blockKey]);

  if (textIsEmpty()) {
    return (
      <div>
        <EditorBlock {...props} />
      </div>
    );
  }

  if (props.blockProps.readOnly) {
    return (
      <StyledHeaderContainer id={blockKey} onClick={handleClick} ref={ref}>
        <Tooltip
          content={translate('RICHTEXT.TOC_TOOLTIP_DEFAULT_TEXT')}
          position="top-center"
          timing="delay"
          icon={<IconLink />}
        >
          <EditorBlock {...props} />
        </Tooltip>
      </StyledHeaderContainer>
    );
  }

  return (
    <div id={blockKey} ref={ref}>
      <EditorBlock {...props} />
    </div>
  );
};

const StyledHeaderContainer = styled.div`
  cursor: pointer;
`;
